import apiClient from 'api/common/common'
import { PositionAssignmentRequest, PositionContractRequest, PositionSelectRequest } from 'api/common/requests'
import { PositionAssignmentResponse, PositionContractResponse, PositionOneResponse, PositionResponse, PositionSelectResponse } from 'api/common/responses'
import { Status } from 'api/common/statuses'
import { AxiosError, AxiosResponse } from 'axios'
import { PositionNumberType } from './common/constants'

/**
 * ポジション一覧取得API
 * @param request
 * @param callback
 */
export const positionsAPI = async (callback: (response: PositionResponse) => void) => {
  await apiClient
    .get('/position')
    .then((response: AxiosResponse<PositionResponse>) => {
      const status = response?.headers['x-aqc-status'] ?? 'failed'
      if (status === Status.Success) {
        callback(response?.data)
      }
    })
    .catch((error: AxiosError) => {
      if (error.response?.status === 401) {
        // @todo ログイン画面に遷移する
      } else {
        console.error(error)
      }
    })
}

/**
 * ポジション取得API
 * @param request
 * @param callback
 */
export const positionAPI = async (positionId: PositionNumberType, callback: (status: Status, response: PositionOneResponse) => void) => {
  await apiClient
    .get(`/position/${positionId}`)
    .then((response: AxiosResponse<PositionOneResponse>) => {
      const status = response?.headers['x-aqc-status'] ?? 'failed'
      callback(status, response?.data)
    })
    .catch((error: AxiosError) => {
      if (error.response?.status === 401) {
        // @todo ログイン画面に遷移する
      } else {
        console.error(error)
      }
    })
}

/**
 * ポジション選択API
 * @param request
 * @param callback
 */
export const positionSelectAPI = async (request: PositionSelectRequest, callback: (result: boolean) => void) => {
  await apiClient
    .post('/position/select', request)
    .then((response: AxiosResponse<PositionSelectResponse>) => {
      const status = response?.headers['x-aqc-status'] ?? 'failed'
      const apiResult = response?.data?.result ?? false
      callback(status === Status.Success && apiResult)
    })
    .catch((error) => {
      console.error(error)
    })
}

/**
 * ポジション契約API
 * @param request
 * @param callback
 */
export const positionContractAPI = async (request: PositionContractRequest, callback: (status: Status, result: boolean) => void) => {
  await apiClient
    .post('/position/contract', request)
    .then((response: AxiosResponse<PositionContractResponse>) => {
      const status = response?.headers['x-aqc-status'] ?? 'failed'
      const apiResult = response?.data?.result ?? false
      callback(status, apiResult)
    })
    .catch((error) => {
      console.error(error)
    })
}

/**
 * ポジション名義変更API
 * @param request
 * @param callback
 */
export const positionAssignmentAPI = async (request: PositionAssignmentRequest, callback: (status: Status, result: boolean) => void) => {
  await apiClient
    .post('/position/assignment', request)
    .then((response: AxiosResponse<PositionAssignmentResponse>) => {
      const status = response?.headers['x-aqc-status'] ?? 'failed'
      const apiResult = response?.data?.result ?? false
      callback(status, apiResult)
    })
    .catch((error) => {
      console.error(error)
    })
}
